/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Iscameraenabledbydefault4Inputs */

const en_entity_iscameraenabledbydefault4 = /** @type {(inputs: Entity_Iscameraenabledbydefault4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Camera Enabled By Default`)
};

const de_entity_iscameraenabledbydefault4 = /** @type {(inputs: Entity_Iscameraenabledbydefault4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera standardmäßig aktiviert`)
};

/**
* | output |
* | --- |
* | "Is Camera Enabled By Default" |
*
* @param {Entity_Iscameraenabledbydefault4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_iscameraenabledbydefault4 = /** @type {((inputs?: Entity_Iscameraenabledbydefault4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Iscameraenabledbydefault4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_iscameraenabledbydefault4(inputs)
	return de_entity_iscameraenabledbydefault4(inputs)
});
export { entity_iscameraenabledbydefault4 as "entity_isCameraEnabledByDefault" }